import {CustomCode} from "../../../model/common.model";

export class EmployeeNote{
  id: number;
  employeeId: string;
  employeeLastname: string;
  employeeFirstname: string;
  managerId: string;
  managerName: string;
  note: string;
  lastModif: Date;
  perm = NoteVisibility.ALL;
  employeeFullName: string;

  _createSpecialElement(propertyName: string, data: any) {
    if ('perm' === propertyName) {
      this.perm = NoteVisibility.retrieveFromCode(data);
      return true;
    }
    return false;
  }
}


export class NoteVisibility extends CustomCode{
  public static _registered = new Map<string, NoteVisibility>();

  // ALL ("ALL"),
  // ADMIN ("ADMIN"),
  // PRIVATE ("PRIVATE");

  static ALL = new NoteVisibility('ALL');
  static ADMIN = new NoteVisibility('ADMIN');
  static PRIVATE = new NoteVisibility('PRIVATE');

  static LIST = Array.from(NoteVisibility._registered.values());

  constructor(code: string) {
    super(code);
    NoteVisibility._registered.set(code, this);
  }


  static retrieveFromCode(code: string): NoteVisibility {
    const res = NoteVisibility._registered.get(code);
    if (!res) {
      console.log('NoteVisibility can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  public toTranslateKey(): string{
    return 'NOTE_VISIBILITY_' + this.code;
  }


}

